import { CloseOutlined, PlusOutlined } from '@ant-design/icons';
import { Spin, Upload as UploadBase, type UploadFile, message as antMessage, Modal } from 'antd';
import { RcFile, UploadChangeParam } from 'antd/es/upload';
import React, { useEffect, useState } from 'react';
// import { postChatGroupImageUpload } from 'src/services/userData/personal';
import { postUpload } from '@/api/system/set';

const encodeAssetPath = (p: string) =>
  p.split('/').map((seg) => (/[^\x00-\x7F]/.test(seg) ? encodeURIComponent(seg) : seg)).join('/');

const resolveThumbUrl = (url: string | undefined) => {
  if (!url) return '';
  if (/^https?:\/\//i.test(url)) return encodeAssetPath(url);
  if (url.startsWith('//')) return encodeAssetPath(`${window.location.protocol}${url}`);
  if (url.startsWith('/')) return encodeAssetPath(`${window.location.origin}${url}`);
  // 处理 host/path 格式（如 123.57.217.68/iot-bucket/...）
  if (/^[\w.-]+(?::\d+)?\//.test(url)) return encodeAssetPath(`${window.location.protocol}//${url}`);
  return encodeAssetPath(`${window.location.origin}/${url}`);
};
const Upload = ({
  value,
  onChange,
  maxCount = 1,
  rules,
  onError,
  disabled,
  showMessage,
  className,
}: {
  value?: string | string[];
  onChange?: (v: string | string[]) => void;
  maxCount?: number;
  rules?: {
    type: 'size' | 'type';
    max?: number;
    fileType?: string[];
    message?: string;
    acceptList?: string[];
  }[];
  onError?: (message: string) => void;
  disabled?: boolean;
  showMessage?: string;
  className?: string;
}) => {
  const [fileList, setFileList] = useState<UploadFile[]>([]);

  useEffect(() => {
    const list = Array.isArray(value) ? value : value ? [value] : [];
    list.length
      ? setFileList(
          // @ts-ignore
          (Array.isArray(value) ? value : [value]).map((k) => ({
            name: k,
            uid: k,
            thumbUrl: resolveThumbUrl(k),
          })),
        )
      : setFileList([]);
  }, [value]);

  const handleChange = ({ fileList: newFileList, file: { status } }: UploadChangeParam<UploadFile<any>>) => {
    if (!status) return;
    if (status === 'removed') {
      onChange?.(maxCount > 1 ? newFileList.map(({ name }) => name) : newFileList.map(({ name }) => name).join(','));
      return;
    }
    setFileList(newFileList);
  };

  // const { modal, message: antMessage } = App.useApp();

  const beforeUpload = ({ size, type }: RcFile) => {
    // console.log(file);

    if (rules?.length) {
      for (let index = 0; index < rules.length; index++) {
        const { type: ruleType, max, message = '文件上传错误', acceptList } = rules[index];

        if (ruleType === 'type' && !acceptList?.includes(type)) {
          onError?.(message);
          antMessage.error(message);
          return false;
        }
        if (ruleType === 'size' && size > (max as number)) {
          onError?.(message);
          antMessage.error(message);
          return false;
        }
      }
    }
  };

  const [spinning, setSpinning] = useState<boolean>(false);
  const customRequest = async ({ file }: any) => {
    setSpinning(true);
    try {
      const res = await postUpload({}, file);
      const url: string = res?.result?.url || '';

      if (!url) return;

      // 上传成功后立即更新 fileList，让图片显示出来
      setFileList([
        {
          name: url,
          uid: url,
          status: 'done',
          thumbUrl: resolveThumbUrl(url),
        },
      ]);

      onChange?.(maxCount > 1 ? [...((value as string[]) || []), url] : url);
    } catch {
    } finally {
      setSpinning(false);
    }
  };

  const onPreview = ({ thumbUrl }: UploadFile) => {
    Modal.info({
      title: '预览',
      icon: null,
      closeIcon: <CloseOutlined />,
      content: (
        <div style={{ marginLeft: '34px', textAlign: 'center' }}>
          <img src={thumbUrl} alt="" style={{ width: '100%', display: 'block', margin: '0 auto', borderRadius: '6px' }}></img>
        </div>
      ),
      // footer: null,
      okText: '关闭',
      centered: true,
      maskClosable: true,
      width: '50%',
    });
  };

  return (
    <Spin spinning={spinning}>
      <UploadBase
        listType="picture-card"
        fileList={fileList}
        onChange={handleChange}
        beforeUpload={beforeUpload}
        customRequest={customRequest}
        maxCount={maxCount}
        onPreview={onPreview}
        accept={'.png, .jpg, .jpeg'}
        disabled={!!disabled}
        className={className || ''}
        progress={undefined}
      >
        {!disabled && !fileList?.length && (
          <div className="common-button">
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>上传</div>
          </div>
        )}
      </UploadBase>
      <div style={{ color: 'gray' }}>{showMessage}</div>
    </Spin>
  );
};

export default Upload;
